import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { usePwcNavigate } from '@app/core/hooks/routing-hooks';
import PwcNavigate from '@app/shared/routing/PwcNavigate';
import { FC } from 'react';
import { RouteConstants } from '../../RouteConstants';
import { cloneToMutableData } from '@app/shared/helpers';
import { Navigate } from 'react-router-dom';
import { selectCapitalStructure } from '@app/core/store/capital-structure-slice-selectors';
import useInstrumentSort from '@app/shared/hooks/useInstrumentSort';

export const CostOfEquity2Page: FC = (): JSX.Element => {
  const { isPwermValid } = useAppSelector((state) => state.project);
  const capitalStructure = useAppSelector(selectCapitalStructure);
  const storedCostOfEquityView = useAppSelector(
    (state) => state.uiValues.userSelections.costOfEquity.selectedTab
  );
  const { generatePath } = usePwcNavigate();
  const instrumentDefinitions = Object.entries(capitalStructure.instrumentDefinitions).map(
    ([instrumentId, instrument]) => {
      return { instrumentId, ...instrument };
    }
  );
  const instrumentTabs = cloneToMutableData(instrumentDefinitions).filter(
    (instrument) => instrument.shouldBeValued
  );

  const sortedInstrumentTabs = useInstrumentSort(instrumentTabs);

  const isStoredCostOfEquityViewInInstruments = sortedInstrumentTabs.some(
    (instrument) => instrument.instrumentId === storedCostOfEquityView
  );

  if (
    !storedCostOfEquityView ||
    (!isStoredCostOfEquityViewInInstruments &&
      storedCostOfEquityView !== RouteConstants.TotalEquityCrossCheck)
  ) {
    return <PwcNavigate route={generatePath(RouteConstants.Summary)} />;
  } else if (
    storedCostOfEquityView &&
    storedCostOfEquityView === RouteConstants.TotalEquityCrossCheck
  ) {
    return <PwcNavigate route={generatePath(RouteConstants.TotalEquityCrossCheck)} />;
  }

  if (!isPwermValid) {
    const newPath = generatePath(`../${RouteConstants.ProjectDetails}`);
    return <Navigate to={newPath} />;
  }

  return (
    <PwcNavigate
      route={generatePath(RouteConstants.InstrumentById, {
        instrumentId: storedCostOfEquityView,
      })}
    />
  );
};
